import { render, staticRenderFns } from "./NewsContentNew.vue?vue&type=template&id=f8e5f7b0&scoped=true&"
import script from "./NewsContentNew.vue?vue&type=script&lang=js&"
export * from "./NewsContentNew.vue?vue&type=script&lang=js&"
import style0 from "./NewsContentNew.vue?vue&type=style&index=0&id=f8e5f7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e5f7b0",
  null
  
)

export default component.exports